import SupervisorPanel from "./SupervisorPanel";

export default SupervisorPanel;
